import { t as e } from "./utils-DiFe-_ei.js";
import { i as t, n, r, t as i } from "./dist-By11B3Nf.js";
import { a, n as o } from "./dist-7tgynhKG.js";
import { a as s, c, i as l, l as u, n as d, o as f, r as p, t as m } from "./es2015-Dfq2CQHn.js";
import { t as h } from "./dist-B3lndwlS.js";
import { t as g } from "./dist-CUIQpIad.js";
import { t as _ } from "./createLucideIcon-CJLgHpqc.js";
import { t as v } from "./check-hnLqiRGn.js";
import { t as y } from "./chevron-down-D8vOGVnQ.js";
import { i as b, n as x, r as S, t as C } from "./dist-8NAz9rgL.js";
import { n as w, t as T } from "./dist-BCghvxHR.js";
import { n as E } from "./dist-Bl9r4eY0.js";
import * as D from "react";
import { Fragment as O, jsx as k, jsxs as A } from "react/jsx-runtime";
import * as j from "react-dom";
var M = _("chevron-up", [["path", {
	d: "m18 15-6-6-6 6",
	key: "153udz"
}]]);
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+number@1.1.2/node_modules/@radix-ui/number/dist/index.mjs
function N(e, [t, n]) {
	return Math.min(n, Math.max(t, e));
}
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-previous@1.1.2_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-use-previous/dist/index.mjs
function ee(e) {
	let t = D.useRef({
		value: e,
		previous: e
	});
	return D.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-select@2.3.4_@types+react-dom@19.2.3_@types+react@19.2.17__@types+react_fd477e6ad8e553d64e5af0a8b0eeb823/node_modules/@radix-ui/react-select/dist/index.mjs
var P = Object.defineProperty, F = (e, t) => P(e, "name", {
	value: t,
	configurable: !0
}), te = [
	" ",
	"Enter",
	"ArrowUp",
	"ArrowDown"
], I = [" ", "Enter"], L = "Select", [R, z, B] = w(L), [V, H] = t(L, [B, b]), U = b(), [W, G] = V(L), [ne, K] = V(L);
function q(e) {
	let { __scopeSelect: t, children: n, open: r, defaultOpen: a, onOpenChange: o, value: s, defaultValue: c, onValueChange: l, dir: d, name: f, autoComplete: p, disabled: m, required: h, form: g, internal_do_not_use_render: _ } = e, v = U(t), [y, b] = D.useState(null), [x, C] = D.useState(null), [w, E] = D.useState(!1), O = T(d), [A, j] = i({
		prop: r,
		defaultProp: a ?? !1,
		onChange: o,
		caller: L
	}), [M, N] = i({
		prop: s,
		defaultProp: c,
		onChange: l,
		caller: L
	}), ee = D.useRef(null), P = D.useRef(M);
	D.useEffect(() => {
		let e = g ? y?.ownerDocument.getElementById(g) : y?.form;
		if (e instanceof HTMLFormElement) {
			let t = /* @__PURE__ */ F(() => N(P.current), "reset");
			return e.addEventListener("reset", t), () => e.removeEventListener("reset", t);
		}
	}, [
		g,
		y,
		N
	]);
	let te = !y || !!g || !!y.closest("form"), [I, z] = D.useState(/* @__PURE__ */ new Set()), B = u(), V = Array.from(I).map((e) => e.props.value).join(";"), H = D.useCallback((e) => {
		z((t) => new Set(t).add(e));
	}, []), G = D.useCallback((e) => {
		z((t) => {
			let n = new Set(t);
			return n.delete(e), n;
		});
	}, []), K = {
		required: h,
		trigger: y,
		onTriggerChange: b,
		valueNode: x,
		onValueNodeChange: C,
		valueNodeHasChildren: w,
		onValueNodeHasChildrenChange: E,
		contentId: B,
		value: M,
		onValueChange: N,
		open: A,
		onOpenChange: j,
		dir: O,
		triggerPointerDownPosRef: ee,
		disabled: m,
		name: f,
		autoComplete: p,
		form: g,
		nativeOptions: I,
		nativeSelectKey: V,
		isFormControl: te
	};
	return /* @__PURE__ */ k(S, {
		...v,
		children: /* @__PURE__ */ k(W, {
			scope: t,
			...K,
			children: /* @__PURE__ */ k(R.Provider, {
				scope: t,
				children: /* @__PURE__ */ k(ne, {
					scope: t,
					onNativeOptionAdd: H,
					onNativeOptionRemove: G,
					children: He(_) ? _(K) : n
				})
			})
		})
	});
}
F(q, "SelectProvider");
var re = /* @__PURE__ */ F((e) => {
	let { __scopeSelect: t, children: n, ...r } = e;
	return /* @__PURE__ */ k(q, {
		__scopeSelect: t,
		...r,
		internal_do_not_use_render: ({ isFormControl: e }) => /* @__PURE__ */ A(O, { children: [n, e ? /* @__PURE__ */ k(Ve, { __scopeSelect: t }) : null] })
	});
}, "Select"), ie = "SelectTrigger", J = /* @__PURE__ */ D.forwardRef(/* @__PURE__ */ F(function(e, t) {
	let { __scopeSelect: n, disabled: i = !1, ...o } = e, s = U(n), c = G(ie, n), l = c.disabled || i, u = a(t, c.onTriggerChange), d = z(n), f = D.useRef("touch"), [p, m, g] = Ue((e) => {
		let t = d().filter((e) => !e.disabled), n = We(t, e, t.find((e) => e.value === c.value));
		n !== void 0 && c.onValueChange(n.value);
	}), _ = /* @__PURE__ */ F((e) => {
		l || (c.onOpenChange(!0), g()), e && (c.triggerPointerDownPosRef.current = {
			x: Math.round(e.pageX),
			y: Math.round(e.pageY)
		});
	}, "handleOpen");
	return /* @__PURE__ */ k(C, {
		asChild: !0,
		...s,
		children: /* @__PURE__ */ k(h.button, {
			type: "button",
			role: "combobox",
			"aria-controls": c.open ? c.contentId : void 0,
			"aria-expanded": c.open,
			"aria-required": c.required,
			"aria-autocomplete": "none",
			dir: c.dir,
			"data-state": c.open ? "open" : "closed",
			disabled: l,
			"data-disabled": l ? "" : void 0,
			"data-placeholder": $(c.value) ? "" : void 0,
			...o,
			ref: u,
			onClick: r(o.onClick, (e) => {
				e.currentTarget.focus(), f.current !== "mouse" && _(e);
			}),
			onPointerDown: r(o.onPointerDown, (e) => {
				f.current = e.pointerType;
				let t = e.target;
				t.hasPointerCapture(e.pointerId) && t.releasePointerCapture(e.pointerId), e.button === 0 && e.ctrlKey === !1 && e.pointerType === "mouse" && (_(e), e.preventDefault());
			}),
			onKeyDown: r(o.onKeyDown, (e) => {
				let t = p.current !== "";
				!(e.ctrlKey || e.altKey || e.metaKey) && e.key.length === 1 && m(e.key), !(t && e.key === " ") && te.includes(e.key) && (_(), e.preventDefault());
			})
		})
	});
}, "SelectTrigger")), ae = "SelectValue", oe = /* @__PURE__ */ D.forwardRef(/* @__PURE__ */ F(function(e, t) {
	let { __scopeSelect: r, className: i, style: o, children: s, placeholder: c = "", ...l } = e, u = G(ae, r), { onValueNodeHasChildrenChange: d } = u, f = s !== void 0, p = a(t, u.onValueNodeChange);
	n(() => {
		d(f);
	}, [d, f]);
	let m = $(u.value);
	return /* @__PURE__ */ k(h.span, {
		...l,
		asChild: !m && l.asChild,
		ref: p,
		style: { pointerEvents: "none" },
		children: /* @__PURE__ */ k(D.Fragment, { children: m ? c : s }, m ? "placeholder" : "value")
	});
}, "SelectValue")), se = /* @__PURE__ */ D.forwardRef(/* @__PURE__ */ F(function(e, t) {
	let { __scopeSelect: n, children: r, ...i } = e;
	return /* @__PURE__ */ k(h.span, {
		"aria-hidden": !0,
		...i,
		ref: t,
		children: r || "▼"
	});
}, "SelectIcon")), [ce, le] = V("SelectPortal", { forceMount: void 0 }), ue = /* @__PURE__ */ F((e) => {
	let { __scopeSelect: t, forceMount: n, ...r } = e;
	return /* @__PURE__ */ k(ce, {
		scope: e.__scopeSelect,
		forceMount: n,
		children: /* @__PURE__ */ k(l, {
			asChild: !0,
			...r
		})
	});
}, "SelectPortal"), Y = "SelectContent", de = /* @__PURE__ */ D.forwardRef(/* @__PURE__ */ F(function(e, t) {
	let r = le(Y, e.__scopeSelect), { forceMount: i = r.forceMount, ...a } = e, o = G(Y, e.__scopeSelect), [s, c] = D.useState();
	return n(() => {
		c(new DocumentFragment());
	}, []), /* @__PURE__ */ k(g, {
		present: i || o.open,
		children: ({ present: e }) => e ? /* @__PURE__ */ k(he, {
			...a,
			ref: t
		}) : /* @__PURE__ */ k(fe, {
			...a,
			fragment: s
		})
	});
}, "SelectContent")), fe = /* @__PURE__ */ D.forwardRef(/* @__PURE__ */ F(function(e, t) {
	let { __scopeSelect: n, children: r, fragment: i } = e;
	return i ? j.createPortal(/* @__PURE__ */ k(pe, {
		scope: n,
		children: /* @__PURE__ */ k(R.Slot, {
			scope: n,
			children: /* @__PURE__ */ k("div", {
				ref: t,
				children: r
			})
		})
	}), i) : null;
}, "SelectContentFragment")), X = 10, [pe, Z] = V(Y), me = o("SelectContent.RemoveScroll"), he = /* @__PURE__ */ D.forwardRef(/* @__PURE__ */ F(function(e, t) {
	let { __scopeSelect: n } = e, { position: i = "item-aligned", onCloseAutoFocus: o, onEscapeKeyDown: c, onPointerDownOutside: l, side: u, sideOffset: h, align: g, alignOffset: _, arrowPadding: v, collisionBoundary: y, collisionPadding: b, sticky: x, hideWhenDetached: S, avoidCollisions: C, ...w } = e, T = G(Y, n), [E, O] = D.useState(null), [A, j] = D.useState(null), M = a(t, O), [N, ee] = D.useState(null), [P, te] = D.useState(null), I = z(n), [L, R] = D.useState(!1), B = D.useRef(!1);
	D.useEffect(() => {
		if (E) return m(E);
	}, [E]), p();
	let V = D.useCallback((e) => {
		let [t, ...n] = I().map((e) => e.ref.current), [r] = n.slice(-1), i = document.activeElement;
		for (let n of e) if (n === i || (n?.scrollIntoView({ block: "nearest" }), n === t && A && (A.scrollTop = 0), n === r && A && (A.scrollTop = A.scrollHeight), n?.focus(), document.activeElement !== i)) return;
	}, [I, A]), H = D.useCallback(() => V([N, E]), [
		V,
		N,
		E
	]);
	D.useEffect(() => {
		L && H();
	}, [L, H]);
	let { onOpenChange: U, triggerPointerDownPosRef: W } = T;
	D.useEffect(() => {
		if (E) {
			let e = {
				x: 0,
				y: 0
			}, t = /* @__PURE__ */ F((t) => {
				e = {
					x: Math.abs(Math.round(t.pageX) - (W.current?.x ?? 0)),
					y: Math.abs(Math.round(t.pageY) - (W.current?.y ?? 0))
				};
			}, "handlePointerMove"), n = /* @__PURE__ */ F((n) => {
				e.x <= 10 && e.y <= 10 ? n.preventDefault() : n.composedPath().includes(E) || U(!1), document.removeEventListener("pointermove", t), W.current = null;
			}, "handlePointerUp");
			return W.current !== null && (document.addEventListener("pointermove", t), document.addEventListener("pointerup", n, {
				capture: !0,
				once: !0
			})), () => {
				document.removeEventListener("pointermove", t), document.removeEventListener("pointerup", n, { capture: !0 });
			};
		}
	}, [
		E,
		U,
		W
	]), D.useEffect(() => {
		let e = /* @__PURE__ */ F(() => U(!1), "close");
		return window.addEventListener("blur", e), window.addEventListener("resize", e), () => {
			window.removeEventListener("blur", e), window.removeEventListener("resize", e);
		};
	}, [U]);
	let [ne, K] = Ue((e) => {
		let t = I().filter((e) => !e.disabled), n = We(t, e, t.find((e) => e.ref.current === document.activeElement));
		n && setTimeout(() => n.ref.current?.focus());
	}), q = D.useCallback((e, t, n) => {
		let r = !B.current && !n;
		(T.value !== void 0 && T.value === t || r) && (ee(e), r && (B.current = !0));
	}, [T.value]), re = D.useCallback(() => E?.focus(), [E]), ie = D.useCallback((e, t, n) => {
		let r = !B.current && !n;
		(T.value !== void 0 && T.value === t || r) && te(e);
	}, [T.value]), J = i === "popper" ? _e : ge, ae = J === _e ? {
		side: u,
		sideOffset: h,
		align: g,
		alignOffset: _,
		arrowPadding: v,
		collisionBoundary: y,
		collisionPadding: b,
		sticky: x,
		hideWhenDetached: S,
		avoidCollisions: C
	} : {};
	return /* @__PURE__ */ k(pe, {
		scope: n,
		content: E,
		viewport: A,
		onViewportChange: j,
		itemRefCallback: q,
		selectedItem: N,
		onItemLeave: re,
		itemTextRefCallback: ie,
		focusSelectedItem: H,
		selectedItemText: P,
		position: i,
		isPositioned: L,
		searchRef: ne,
		children: /* @__PURE__ */ k(d, {
			as: me,
			allowPinchZoom: !0,
			children: /* @__PURE__ */ k(s, {
				asChild: !0,
				trapped: T.open,
				onMountAutoFocus: (e) => {
					e.preventDefault();
				},
				onUnmountAutoFocus: r(o, (e) => {
					T.trigger?.focus({ preventScroll: !0 }), e.preventDefault();
				}),
				children: /* @__PURE__ */ k(f, {
					asChild: !0,
					disableOutsidePointerEvents: !0,
					onEscapeKeyDown: c,
					onPointerDownOutside: l,
					onFocusOutside: (e) => e.preventDefault(),
					onDismiss: () => T.onOpenChange(!1),
					children: /* @__PURE__ */ k(J, {
						role: "listbox",
						id: T.contentId,
						"data-state": T.open ? "open" : "closed",
						dir: T.dir,
						onContextMenu: (e) => e.preventDefault(),
						...w,
						...ae,
						onPlaced: () => R(!0),
						ref: M,
						style: {
							display: "flex",
							flexDirection: "column",
							outline: "none",
							...w.style
						},
						onKeyDown: r(w.onKeyDown, (e) => {
							let t = e.ctrlKey || e.altKey || e.metaKey;
							if (e.key === "Tab" && e.preventDefault(), !t && e.key.length === 1 && K(e.key), [
								"ArrowUp",
								"ArrowDown",
								"Home",
								"End"
							].includes(e.key)) {
								let t = I().filter((e) => !e.disabled).map((e) => e.ref.current);
								if (["ArrowUp", "End"].includes(e.key) && (t = t.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(e.key)) {
									let n = e.target, r = t.indexOf(n);
									t = t.slice(r + 1);
								}
								setTimeout(() => V(t)), e.preventDefault();
							}
						})
					})
				})
			})
		})
	});
}, "SelectContentImpl")), ge = /* @__PURE__ */ D.forwardRef(/* @__PURE__ */ F(function(e, t) {
	let { __scopeSelect: r, onPlaced: i, ...o } = e, s = G(Y, r), c = Z(Y, r), [l, u] = D.useState(null), [d, f] = D.useState(null), p = a(t, f), m = z(r), g = D.useRef(!1), _ = D.useRef(!0), { viewport: v, selectedItem: y, selectedItemText: b, focusSelectedItem: x } = c, S = D.useCallback(() => {
		if (s.trigger && s.valueNode && l && d && v && y && b) {
			let e = s.trigger.getBoundingClientRect(), t = d.getBoundingClientRect(), n = s.valueNode.getBoundingClientRect(), r = b.getBoundingClientRect();
			if (s.dir !== "rtl") {
				let i = r.left - t.left, a = n.left - i, o = e.left - a, s = e.width + o, c = Math.max(s, t.width), u = window.innerWidth - X, d = N(a, [X, Math.max(X, u - c)]);
				l.style.minWidth = s + "px", l.style.left = d + "px";
			} else {
				let i = t.right - r.right, a = window.innerWidth - n.right - i, o = window.innerWidth - e.right - a, s = e.width + o, c = Math.max(s, t.width), u = window.innerWidth - X, d = N(a, [X, Math.max(X, u - c)]);
				l.style.minWidth = s + "px", l.style.right = d + "px";
			}
			let a = m(), o = window.innerHeight - X * 2, c = v.scrollHeight, u = window.getComputedStyle(d), f = parseInt(u.borderTopWidth, 10), p = parseInt(u.paddingTop, 10), h = parseInt(u.borderBottomWidth, 10), _ = parseInt(u.paddingBottom, 10), x = f + p + c + _ + h, S = Math.min(y.offsetHeight * 5, x), C = window.getComputedStyle(v), w = parseInt(C.paddingTop, 10), T = parseInt(C.paddingBottom, 10), E = e.top + e.height / 2 - X, D = o - E, O = y.offsetHeight / 2, k = y.offsetTop + O, A = f + p + k, j = x - A;
			if (A <= E) {
				let e = a.length > 0 && y === a[a.length - 1].ref.current;
				l.style.bottom = "0px";
				let t = d.clientHeight - v.offsetTop - v.offsetHeight, n = A + Math.max(D, O + (e ? T : 0) + t + h);
				l.style.height = n + "px";
			} else {
				let e = a.length > 0 && y === a[0].ref.current;
				l.style.top = "0px";
				let t = Math.max(E, f + v.offsetTop + (e ? w : 0) + O) + j;
				l.style.height = t + "px", v.scrollTop = A - E + v.offsetTop;
			}
			l.style.margin = `${X}px 0`, l.style.minHeight = S + "px", l.style.maxHeight = o + "px", i?.(), requestAnimationFrame(() => g.current = !0);
		}
	}, [
		m,
		s.trigger,
		s.valueNode,
		l,
		d,
		v,
		y,
		b,
		s.dir,
		i
	]);
	n(() => S(), [S]);
	let [C, w] = D.useState();
	return n(() => {
		d && w(window.getComputedStyle(d).zIndex);
	}, [d]), /* @__PURE__ */ k(ve, {
		scope: r,
		contentWrapper: l,
		shouldExpandOnScrollRef: g,
		onScrollButtonChange: D.useCallback((e) => {
			e && _.current === !0 && (S(), x?.(), _.current = !1);
		}, [S, x]),
		children: /* @__PURE__ */ k("div", {
			ref: u,
			style: {
				display: "flex",
				flexDirection: "column",
				position: "fixed",
				zIndex: C
			},
			children: /* @__PURE__ */ k(h.div, {
				...o,
				ref: p,
				style: {
					boxSizing: "border-box",
					maxHeight: "100%",
					...o.style
				}
			})
		})
	});
}, "SelectItemAlignedPosition")), _e = /* @__PURE__ */ D.forwardRef(/* @__PURE__ */ F(function(e, t) {
	let { __scopeSelect: n, align: r = "start", collisionPadding: i = X, ...a } = e;
	return /* @__PURE__ */ k(x, {
		...U(n),
		...a,
		ref: t,
		align: r,
		collisionPadding: i,
		style: {
			boxSizing: "border-box",
			...a.style,
			"--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
			"--radix-select-content-available-width": "var(--radix-popper-available-width)",
			"--radix-select-content-available-height": "var(--radix-popper-available-height)",
			"--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
			"--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
		}
	});
}, "SelectPopperPosition")), [ve, ye] = V(Y, {}), be = "SelectViewport", xe = /* @__PURE__ */ D.forwardRef(/* @__PURE__ */ F(function(e, t) {
	let { __scopeSelect: n, nonce: i, ...o } = e, s = Z(be, n), c = ye(be, n), l = a(t, s.onViewportChange), u = D.useRef(0);
	return /* @__PURE__ */ A(O, { children: [/* @__PURE__ */ k("style", {
		dangerouslySetInnerHTML: { __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}" },
		nonce: i
	}), /* @__PURE__ */ k(R.Slot, {
		scope: n,
		children: /* @__PURE__ */ k(h.div, {
			"data-radix-select-viewport": "",
			role: "presentation",
			...o,
			ref: l,
			style: {
				position: "relative",
				flex: 1,
				overflow: "hidden auto",
				...o.style
			},
			onScroll: r(o.onScroll, (e) => {
				let t = e.currentTarget, { contentWrapper: n, shouldExpandOnScrollRef: r } = c;
				if (r?.current && n) {
					let e = Math.abs(u.current - t.scrollTop);
					if (e > 0) {
						let r = window.innerHeight - X * 2, i = parseFloat(n.style.minHeight), a = parseFloat(n.style.height), o = Math.max(i, a);
						if (o < r) {
							let i = o + e, a = Math.min(r, i), s = i - a;
							n.style.height = a + "px", n.style.bottom === "0px" && (t.scrollTop = s > 0 ? s : 0, n.style.justifyContent = "flex-end");
						}
					}
				}
				u.current = t.scrollTop;
			})
		})
	})] });
}, "SelectViewport")), [Se, Ce] = V("SelectGroup"), we = /* @__PURE__ */ D.forwardRef(/* @__PURE__ */ F(function(e, t) {
	let { __scopeSelect: n, ...r } = e, i = u();
	return /* @__PURE__ */ k(Se, {
		scope: n,
		id: i,
		children: /* @__PURE__ */ k(h.div, {
			role: "group",
			"aria-labelledby": i,
			...r,
			ref: t
		})
	});
}, "SelectGroup")), Te = "SelectLabel", Ee = /* @__PURE__ */ D.forwardRef(/* @__PURE__ */ F(function(e, t) {
	let { __scopeSelect: n, ...r } = e, i = Ce(Te, n);
	return /* @__PURE__ */ k(h.div, {
		id: i.id,
		...r,
		ref: t
	});
}, "SelectLabel")), De = "SelectItem", [Oe, ke] = V(De), Ae = /* @__PURE__ */ D.forwardRef(/* @__PURE__ */ F(function(e, t) {
	let { __scopeSelect: n, value: i, disabled: o = !1, textValue: s, ...l } = e, d = G(De, n), f = Z(De, n), p = d.value === i, [m, g] = D.useState(s ?? ""), [_, v] = D.useState(!1), y = a(t, c((e) => f.itemRefCallback?.(e, i, o))), b = u(), x = D.useRef("touch"), S = /* @__PURE__ */ F(() => {
		o || (d.onValueChange(i), d.onOpenChange(!1));
	}, "handleSelect");
	return /* @__PURE__ */ k(Oe, {
		scope: n,
		value: i,
		disabled: o,
		textId: b,
		isSelected: p,
		onItemTextChange: D.useCallback((e) => {
			g((t) => t || (e?.textContent ?? "").trim());
		}, []),
		children: /* @__PURE__ */ k(R.ItemSlot, {
			scope: n,
			value: i,
			disabled: o,
			textValue: m,
			children: /* @__PURE__ */ k(h.div, {
				role: "option",
				"aria-labelledby": b,
				"data-highlighted": _ ? "" : void 0,
				"aria-selected": p && _,
				"data-state": p ? "checked" : "unchecked",
				"aria-disabled": o || void 0,
				"data-disabled": o ? "" : void 0,
				tabIndex: o ? void 0 : -1,
				...l,
				ref: y,
				onFocus: r(l.onFocus, () => v(!0)),
				onBlur: r(l.onBlur, () => v(!1)),
				onClick: r(l.onClick, () => {
					x.current !== "mouse" && S();
				}),
				onPointerUp: r(l.onPointerUp, () => {
					x.current === "mouse" && S();
				}),
				onPointerDown: r(l.onPointerDown, (e) => {
					x.current = e.pointerType;
				}),
				onPointerMove: r(l.onPointerMove, (e) => {
					x.current = e.pointerType, o ? f.onItemLeave?.() : x.current === "mouse" && e.currentTarget.focus({ preventScroll: !0 });
				}),
				onPointerLeave: r(l.onPointerLeave, (e) => {
					e.currentTarget === document.activeElement && f.onItemLeave?.();
				}),
				onKeyDown: r(l.onKeyDown, (e) => {
					o || e.target !== e.currentTarget || f.searchRef?.current !== "" && e.key === " " || (I.includes(e.key) && S(), e.key === " " && e.preventDefault());
				})
			})
		})
	});
}, "SelectItem")), Q = "SelectItemText", je = /* @__PURE__ */ D.forwardRef(/* @__PURE__ */ F(function(e, t) {
	let { __scopeSelect: r, className: i, style: o, ...s } = e, l = G(Q, r), u = Z(Q, r), d = ke(Q, r), f = K(Q, r), [p, m] = D.useState(null), g = c((e) => u.itemTextRefCallback?.(e, d.value, d.disabled)), _ = a(t, m, d.onItemTextChange, g), v = p?.textContent, y = D.useMemo(() => /* @__PURE__ */ k("option", {
		value: d.value,
		disabled: d.disabled,
		children: v
	}, d.value), [
		d.disabled,
		d.value,
		v
	]), { onNativeOptionAdd: b, onNativeOptionRemove: x } = f;
	return n(() => (b(y), () => x(y)), [
		b,
		x,
		y
	]), /* @__PURE__ */ A(O, { children: [/* @__PURE__ */ k(h.span, {
		id: d.textId,
		...s,
		ref: _
	}), d.isSelected && l.valueNode && !l.valueNodeHasChildren && !$(l.value) ? j.createPortal(s.children, l.valueNode) : null] });
}, "SelectItemText")), Me = "SelectItemIndicator", Ne = /* @__PURE__ */ D.forwardRef(/* @__PURE__ */ F(function(e, t) {
	let { __scopeSelect: n, ...r } = e;
	return ke(Me, n).isSelected ? /* @__PURE__ */ k(h.span, {
		"aria-hidden": !0,
		...r,
		ref: t
	}) : null;
}, "SelectItemIndicator")), Pe = "SelectScrollUpButton", Fe = /* @__PURE__ */ D.forwardRef(/* @__PURE__ */ F(function(e, t) {
	let r = Z(Pe, e.__scopeSelect), i = ye(Pe, e.__scopeSelect), [o, s] = D.useState(!1), c = a(t, i.onScrollButtonChange);
	return n(() => {
		if (r.viewport && r.isPositioned) {
			let e = function() {
				let e = t.scrollTop > 0;
				s(e);
			};
			F(e, "handleScroll");
			let t = r.viewport;
			return e(), t.addEventListener("scroll", e), () => t.removeEventListener("scroll", e);
		}
	}, [r.viewport, r.isPositioned]), o ? /* @__PURE__ */ k(Re, {
		...e,
		ref: c,
		onAutoScroll: () => {
			let { viewport: e, selectedItem: t } = r;
			e && t && (e.scrollTop -= t.offsetHeight);
		}
	}) : null;
}, "SelectScrollUpButton")), Ie = "SelectScrollDownButton", Le = /* @__PURE__ */ D.forwardRef(/* @__PURE__ */ F(function(e, t) {
	let r = Z(Ie, e.__scopeSelect), i = ye(Ie, e.__scopeSelect), [o, s] = D.useState(!1), c = a(t, i.onScrollButtonChange);
	return n(() => {
		if (r.viewport && r.isPositioned) {
			let e = function() {
				let e = t.scrollHeight - t.clientHeight, n = Math.ceil(t.scrollTop) < e;
				s(n);
			};
			F(e, "handleScroll");
			let t = r.viewport;
			return e(), t.addEventListener("scroll", e), () => t.removeEventListener("scroll", e);
		}
	}, [r.viewport, r.isPositioned]), o ? /* @__PURE__ */ k(Re, {
		...e,
		ref: c,
		onAutoScroll: () => {
			let { viewport: e, selectedItem: t } = r;
			e && t && (e.scrollTop += t.offsetHeight);
		}
	}) : null;
}, "SelectScrollDownButton")), Re = /* @__PURE__ */ D.forwardRef(/* @__PURE__ */ F(function(e, t) {
	let { __scopeSelect: i, onAutoScroll: a, ...o } = e, s = Z("SelectScrollButton", i), c = D.useRef(null), l = z(i), u = D.useCallback(() => {
		c.current !== null && (window.clearInterval(c.current), c.current = null);
	}, []);
	return D.useEffect(() => () => u(), [u]), n(() => {
		l().find((e) => e.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
	}, [l]), /* @__PURE__ */ k(h.div, {
		"aria-hidden": !0,
		...o,
		ref: t,
		style: {
			flexShrink: 0,
			...o.style
		},
		onPointerDown: r(o.onPointerDown, () => {
			c.current === null && (c.current = window.setInterval(a, 50));
		}),
		onPointerMove: r(o.onPointerMove, () => {
			s.onItemLeave?.(), c.current === null && (c.current = window.setInterval(a, 50));
		}),
		onPointerLeave: r(o.onPointerLeave, () => {
			u();
		})
	});
}, "SelectScrollButtonImpl")), ze = /* @__PURE__ */ D.forwardRef(/* @__PURE__ */ F(function(e, t) {
	let { __scopeSelect: n, ...r } = e;
	return /* @__PURE__ */ k(h.div, {
		"aria-hidden": !0,
		...r,
		ref: t
	});
}, "SelectSeparator")), Be = "SelectBubbleInput", Ve = /* @__PURE__ */ D.forwardRef(/* @__PURE__ */ F(function({ __scopeSelect: e, ...t }, n) {
	let r = G(Be, e), { value: i, onValueChange: o, required: s, disabled: c, name: l, autoComplete: u, form: d } = r, { nativeOptions: f, nativeSelectKey: p } = r, m = D.useRef(null), g = a(n, m), _ = i ?? "", v = ee(_), y = Array.from(f).some((e) => (e.props.value ?? "") === "");
	return D.useEffect(() => {
		let e = m.current;
		if (!e) return;
		let t = window.HTMLSelectElement.prototype, n = Object.getOwnPropertyDescriptor(t, "value").set;
		if (v !== _ && n) {
			let t = new Event("change", { bubbles: !0 });
			n.call(e, _), e.dispatchEvent(t);
		}
	}, [v, _]), /* @__PURE__ */ A(h.select, {
		"aria-hidden": !0,
		required: s,
		tabIndex: -1,
		name: l,
		autoComplete: u,
		disabled: c,
		form: d,
		onChange: (e) => o(e.target.value),
		...t,
		style: {
			...E,
			...t.style
		},
		ref: g,
		defaultValue: _,
		children: [$(i) && !y ? /* @__PURE__ */ k("option", { value: "" }) : null, Array.from(f)]
	}, p);
}, "SelectBubbleInput"));
function He(e) {
	return typeof e == "function";
}
F(He, "isFunction");
function $(e) {
	return e === "" || e === void 0;
}
F($, "shouldShowPlaceholder");
function Ue(e) {
	let t = c(e), n = D.useRef(""), r = D.useRef(0), i = D.useCallback((e) => {
		let i = n.current + e;
		t(i), (/* @__PURE__ */ F((function e(t) {
			n.current = t, window.clearTimeout(r.current), t !== "" && (r.current = window.setTimeout(() => e(""), 1e3));
		}), "updateSearch"))(i);
	}, [t]), a = D.useCallback(() => {
		n.current = "", window.clearTimeout(r.current);
	}, []);
	return D.useEffect(() => () => window.clearTimeout(r.current), []), [
		n,
		i,
		a
	];
}
F(Ue, "useTypeaheadSearch");
function We(e, t, n) {
	let r = t.length > 1 && Array.from(t).every((e) => e === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1, a = Ge(e, Math.max(i, 0));
	r.length === 1 && (a = a.filter((e) => e !== n));
	let o = a.find((e) => e.textValue.toLowerCase().startsWith(r.toLowerCase()));
	return o === n ? void 0 : o;
}
F(We, "findNextItem");
function Ge(e, t) {
	return e.map((n, r) => e[(t + r) % e.length]);
}
F(Ge, "wrapArray");
//#endregion
//#region src/foundations/select/select.tsx
var Ke = re, qe = we, Je = oe, Ye = D.forwardRef(({ className: t, children: n, ...r }, i) => /* @__PURE__ */ A(J, {
	ref: i,
	className: e("flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background md:text-sm data-placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1", t),
	...r,
	children: [n, /* @__PURE__ */ k(se, {
		asChild: !0,
		children: /* @__PURE__ */ k(y, { className: "h-4 w-4 opacity-50" })
	})]
}));
Ye.displayName = J.displayName;
var Xe = D.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ k(Fe, {
	ref: r,
	className: e("flex cursor-default items-center justify-center py-1", t),
	...n,
	children: /* @__PURE__ */ k(M, { className: "h-4 w-4" })
}));
Xe.displayName = Fe.displayName;
var Ze = D.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ k(Le, {
	ref: r,
	className: e("flex cursor-default items-center justify-center py-1", t),
	...n,
	children: /* @__PURE__ */ k(y, { className: "h-4 w-4" })
}));
Ze.displayName = Le.displayName;
var Qe = D.forwardRef(({ className: t, children: n, position: r = "popper", ...i }, a) => /* @__PURE__ */ k(ue, { children: /* @__PURE__ */ A(de, {
	ref: a,
	className: e("relative z-50 max-h-[--radix-select-content-available-height] min-w-32 overflow-y-auto overflow-x-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-select-content-transform-origin]", r === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1", t),
	position: r,
	...i,
	children: [
		/* @__PURE__ */ k(Xe, {}),
		/* @__PURE__ */ k(xe, {
			className: e("p-1", r === "popper" && "h-(--radix-select-trigger-height) w-full min-w-(--radix-select-trigger-width)"),
			children: n
		}),
		/* @__PURE__ */ k(Ze, {})
	]
}) }));
Qe.displayName = de.displayName;
var $e = D.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ k(Ee, {
	ref: r,
	className: e("py-1.5 pl-8 pr-2 text-sm font-semibold", t),
	...n
}));
$e.displayName = Ee.displayName;
var et = D.forwardRef(({ className: t, children: n, ...r }, i) => /* @__PURE__ */ A(Ae, {
	ref: i,
	className: e("relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50", t),
	...r,
	children: [/* @__PURE__ */ k("span", {
		className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
		children: /* @__PURE__ */ k(Ne, { children: /* @__PURE__ */ k(v, { className: "h-4 w-4" }) })
	}), /* @__PURE__ */ k(je, { children: n })]
}));
et.displayName = Ae.displayName;
var tt = D.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ k(ze, {
	ref: r,
	className: e("-mx-1 my-1 h-px bg-muted", t),
	...n
}));
tt.displayName = ze.displayName;
//#endregion
export { $e as a, tt as c, et as i, Ye as l, Qe as n, Ze as o, qe as r, Xe as s, Ke as t, Je as u };

//# sourceMappingURL=select-bS-wme6I.js.map